const modulo = {
  ANALISE: 'analise',
  PUBLICO: 'publico',
  ASSINATURA: 'assinatura'
}

export default modulo



// WEBPACK FOOTER //
// ./src/utils/modulo.js